import React from "react";
import { Card } from "react-bootstrap";
import "../Cards/card.css";
import { NavLink } from "react-router-dom";

const Cards = ({ destination }) => {
  return (
    <div className="img-box">
      <NavLink className="body-text text-dark text-decoration-none" to="/tours">
        <Card className="rounded-2 shadow-sm">
          <Card.Img
            variant="top"
            src={destination.image}
            className="fixed-img"
            alt={destination.name}
          />
          <Card.Body>
            <Card.Title className="h6">{destination.name}</Card.Title>
            <span className="tours text-muted">{destination.tours}</span>
          </Card.Body>
        </Card>
      </NavLink>
    </div>
  );
};

export default Cards;
